import { styled } from 'styled-components';

export const TabButtonLink = styled.a`
  position: relative;
  ${({ theme }) => theme.typography.headingRegular}
  padding: ${({ theme }) => `${theme.sizing.small} ${theme.sizing.medium}`};
  transition: opacity ${({ theme }) => theme.animation.duration.default}
    ${({ theme }) => theme.animation.easing.moving};
  opacity: ${({ theme }) => theme.opacity.secondary};

  &.active {
    border-bottom: ${({ theme }) =>
      `2px solid ${theme.colours.interface.main}`};
    opacity: 1;
  }

  &:hover {
    color: ${({ theme }) => theme.colours.ink.primary.main};
    opacity: 1;
  }
`;

export const TabButtonGroup = styled.div`
  display: flex;
`;
